import * as types from './mutation-types'

let defaultObject = () => ({
  data: {}
})

export default {
  [types.SET_PRODUCT] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.product = payload
  },
  [types.SET_PRODUCTS] (state, payload) {
    state.products = payload.data
    state.pagination = payload.meta.pagination
  }
}
